/**
 * Created by Andrey Popov on 10.11.22
 */

const ClimbableView = cc.Node.extend({
    ctor: function (climbable, unitView) {
        this._super();

        this.unitView = unitView;
        this.climbable = climbable;

        cleverapps.effects.preload(this.getClimbEvents(), this.unitView);

        if (cleverapps.gameModes.showTriggerLock && Climbable.GetTrigger(climbable.unit)) {
            this.showTriggerLock();
        }
    },

    customClimb: function (newUnit, callback) {
        Map2dLocation.currentLocation.counter.inc();
        const newUnitView = newUnit.onGetView();
        newUnitView.setVisible(false);

        this.unitView.replaceParentSamePlace(Map2d.currentMap.getMapView().animations, {
            keepScale: true
        });
        this.unitView.sprite.setAnimation(0, "climb", false);
        this.unitView.sprite.setCompleteListenerOnce(() => {
            this.unitView.removeFromParent();
            newUnitView.setVisible(true);
            Map2dLocation.currentLocation.counter.dec();
            callback();
        });
    },

    beforeStageUpdate: function () {
        const prizeView = this.unitView.getAdditionalView("prize");
        if (prizeView) {
            prizeView.hide();
        }

        if (this.triggerLock) {
            StandartAnimations.disappear(this.triggerLock);
            delete this.triggerLock;
        }
    },

    hasCustomAnimation: function () {
        const sprite = this.unitView.sprite;
        return (sprite instanceof cleverapps.Spine || sprite instanceof LazyAsset && sprite.isLoaded() && sprite.isSpine()) && sprite.hasAnimation("climb");
    },

    updateStage: function (newUnit, callback) {
        if (!this.climbable.unit.getData().simpleClimb && !this.hasCustomAnimation()) {
            this.unitView.removeFromParent();
            callback();
            return;
        }

        cleverapps.effects.fire(this.getClimbEvents(), this.unitView);

        if (this.hasCustomAnimation()) {
            this.customClimb(newUnit, callback);
        } else {
            this.unitView.sprite.runAction(UnitView.runUpgradeAnimation(this.unitView, newUnit.onGetView(), {
                flash: true
            })).setFinalize(callback);
        }
    },

    getClimbEvents: function () {
        const unit = this.climbable.unit;
        return [
            `unit.climb.${unit.code}.${unit.stage}`,
            `unit.climb.${unit.code}`,
            "unit.climb"
        ];
    },

    showTriggerLock: function () {
        const styles = cleverapps.styles.ClimbableView.triggerLock;
        const triggerLock = this.triggerLock = new cleverapps.Spine(bundles.fog.jsons.fog_blocker_json);
        triggerLock.setAnimation(0, "idle", true);
        triggerLock.setAlignment(styles);

        const trigger = Climbable.GetTrigger(this.climbable.unit);

        let target = Map2d.currentMap.listAvailableUnits().filter((unit) => unit.code === trigger.code)[0];

        if (!target) {
            target = Map2d.currentMap.fogs.listFakeUnits((unit) => unit.code === trigger.code)[0];
        }
        
        if (!target) {
            if (cleverapps.config.editorMode || cleverapps.config.adminMode) {
                return;
            }

            cleverapps.throwAsync(`Climbable unit not found!: check unit: ${trigger.code} in scene`);
        }

        const iconSlot = triggerLock.hasSlot("slot_icon") && triggerLock.getSlot("slot_icon");
        if (iconSlot) {
            const unitIcon = UnitView.getUnitImage(UnitsLibrary.LastStage(target.code), { preferStatic: true });
            cleverapps.UI.fitToBox(unitIcon, styles.icon);
            iconSlot.addChild(unitIcon);
        }

        if (!cleverapps.config.editorMode) {
            cleverapps.UI.applyHover(triggerLock);
            cleverapps.UI.onClick(triggerLock, () => {
                cleverapps.focusManager.display({
                    focus: "ShowTriggerLock",
                    actions: [
                        function (f) {
                            Map2dScroller.currentScroller.zoomIn(target, {
                                zoom: 1.33
                            });
                            Map2d.currentMap.highlightUnit(target, f);
                        },

                        function (f) {
                            setTimeout(f, 1000);
                        },

                        function (f) {
                            Map2dScroller.currentScroller.zoomOut();
                            Map2d.currentMap.unhighlightUnit();
                            f();
                        }
                    ]
                });
            });
        }

        this.addChild(triggerLock);

        StandartAnimations.showUp(triggerLock);
    }
});

cleverapps.styles.ClimbableView = {
    triggerLock: {
        x: { align: "center" },
        y: { align: "center" },

        icon: {
            width: 80,
            height: 80
        }
    }
};